"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCORDION = void 0;
const ACCORDION = exports.ACCORDION = 'accordion';
